export default __webpack_public_path__ + "static/media/email.2ab5d06b.svg";